let wsClient;
let reconnectTimeout;
const eventEmitter = new EventTarget(); // Centralized event emitter
export const connectWebsocket = () => {
  const token = localStorage.getItem("userLoginToken");
  if (!token) {
    console.error("No user token found. WebSocket connection aborted.");
    return null;
  }
  // const WEB_SOCKETS_URL =
  //   "wss://uxg1xfn72j.execute-api.us-east-1.amazonaws.com/Prod"; // sandbox url
  const WEB_SOCKETS_URL =
    "wss://ku02cvstje.execute-api.us-west-2.amazonaws.com/Prod"; // live url
  console.log(`${WEB_SOCKETS_URL}?authorization=${token}`);
  if (wsClient && wsClient.readyState === WebSocket.OPEN) {
    console.log("WebSocket already connected");
    return wsClient;
  }
  wsClient = new WebSocket(`${WEB_SOCKETS_URL}?authorization=${token}`);
  wsClient.onopen = () => {
    console.log("Connected to WebSocket server");
    if (reconnectTimeout) {
      clearTimeout(reconnectTimeout); // Clear any existing reconnection attempts
    }
  };

  // wsClient.addEventListener("message", (msg) => {
  //   console.log("message received", msg);
  // });
  wsClient.onmessage = (msg) => {
    console.log("message received", msg);
    const data = JSON.parse(msg.data);

    // Dispatch the message as a custom event
    const event = new CustomEvent("websocket-message", { detail: data });
    eventEmitter.dispatchEvent(event);
  };
  wsClient.onerror = () => {
    reconnect();
  }
  wsClient.onclose = () => {
    console.log("DisConnected to WebSocket server");
    reconnect();
  };
  return wsClient;
};

const reconnect = () => {
  const reconnectDelay = 1000; // Delay in milliseconds before attempting reconnection
  if (reconnectTimeout) {
    clearTimeout(reconnectTimeout); // Clear existing timeout to prevent multiple triggers
  }
  reconnectTimeout = setTimeout(() => {
    console.log("Reconnecting to WebSocket...");
    connectWebsocket();
  }, reconnectDelay);
};

export const closeWebsocket = () => {
  if (wsClient) {
    console.log("Closing WebSocket connection...");
    wsClient.close();
    wsClient = null; // Reset the WebSocket client
  }
  if (reconnectTimeout) {
    clearTimeout(reconnectTimeout); // Clear any pending reconnection attempts
    reconnectTimeout = null;
  }
};
export const websocketEventEmitter = eventEmitter;
export const getWs = () => wsClient || connectWebsocket();
